(function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    class AnimatedAccordion {
    constructor(details) {
    this.el = details;
    this.summary = details.querySelector('summary');
    this.content = details.querySelector('.accordion__content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    if (!this.summary || !this.content) return;
    this.summary.addEventListener('click', (event) => this.onClick(event));
    }

    onClick(event) {
    event.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
    this.open();
    } else if (this.isExpanding || this.el.open) {
    this.shrink();
    }
    }

    shrink() {
    this.isClosing = true;
    const startHeight = this.el.offsetHeight + 'px';
    const endHeight = this.summary.offsetHeight + 'px';
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate(
    { height: [startHeight, endHeight] },
    { duration: 300, easing: 'ease-out' }
    );
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
    this.el.style.height = this.el.offsetHeight + 'px';
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
    }

    expand() {
    this.isExpanding = true;
    const startHeight = this.el.offsetHeight + 'px';
    const endHeight = (this.summary.offsetHeight + this.content.offsetHeight) + 'px';
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate(
    { height: [startHeight, endHeight] },
    { duration: 300, easing: 'ease-out' }
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
    }
    }

    function initAccordions(root) {
    root = root || document;
    var list = root.querySelectorAll('.product__accordion.accordion details');
    list.forEach(function (details) {
    if (details.dataset.animatedAccordion) return;
    details.dataset.animatedAccordion = 'true';
    new AnimatedAccordion(details);
    });
    }

    document.addEventListener('DOMContentLoaded', function () { initAccordions(); });
    document.addEventListener('shopify:section:load', function (event) { initAccordions(event.target); });
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAccordions();
    }
    })();